export default __webpack_public_path__ + "static/media/@3x_case_2(780_830).fca45da6.png";